import { filter } from 'rxjs/operators';
import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { ApplicationDetailsModel } from 'src/app/models/farmers-application.model';
import { DashboardService } from 'src/app/services/dashboard.service';
import { FarmersApplicationService } from 'src/app/services/farmers-application.service';
import { OnFarmMiService } from 'src/app/services/on-farm-mi.service';
import { DomSanitizer } from '@angular/platform-browser';
import { VendorDashboardService } from 'src/app/services/vendor-dashboard.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { JEService } from 'src/app/services/je-services.service';
import { ChallanService } from 'src/app/services/challan-services.service';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { Location } from '@angular/common'


@Component({
  selector: 'app-consent-form',
  templateUrl: './consent-form.component.html',
  styleUrls: ['./consent-form.component.scss'],
})
export class ConsentFormComponent implements OnInit {

  @Output() appDataLoadedEvent = new EventEmitter<string>();

  responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 5
    },
    {
      breakpoint: '768px',
      numVisible: 3
    },
    {
      breakpoint: '560px',
      numVisible: 1
    }
  ];
  
  userId: any;
  autoId: any;
  appDetails: any;
  public sanctionLetterData: any;
  public appId: any;
  public progID: any;
  public sanctionLetterDataForTable: any[];
  miDetails: any;
  PondVerData: any;
  PondVerDataStage2: any;
  PondVerDataStage3: any;
  calculatedSubsidyDataForMIPhys: any;
  preEstimateDetails: any;
  physicalSurveyDetails: any;

  optionsPreEstimate: any;
  overlaysPreEstimate: any[];
  showMapPreEstimate: any;

  optionsJE: any;
  overlaysJE: any[];
  showMapJE: any;

  optionsXEN: any;
  overlaysXEN: any[];
  showMapXEN: any;

  optionsSDO: any;
  overlaysSDO: any[];
  showMapSDO: any;

  showMapJETankS1: any;
  showMapSDOTankS1: any;
  showMapXENTankS1: any; 

  showMapJETankS2: any;
  showMapSDOTankS2: any;
  showMapXENTankS2: any; 


  miSurveyMapoptions: any;
  miSurveyoverlays: any[];
  miSurveyXENMapoptions: any;
  miSurveyXENoverlays: any[];

  applicationDetails: ApplicationDetailsModel = new ApplicationDetailsModel();
  applicationStatus: any;
  vendorApplicationDetails: any;
  // farmerDetails: any;
  farmerPreviousSubsidies: any = [];
  farmerId: any;
  displayFileDialog: boolean;
  state: string = 'default';
  rotatableFilePath: any;
  public totalArea = 0;
  displayCustom: boolean;
  displayCustom1: boolean;
  activeIndex: number = 0;
  items: any[];
  selectedStatus: any;
  remarks: String;
  //appId: String;
  vendorId: any;
  programId: any;
  isActionSectionEnabled: boolean;

  public isProDataCalculated: boolean = false;
  public proCalculatedData: any;
  public statusCode: any;
  public isPrintClicked: boolean = false;
  public cropType: any;
  public selectedCropType: any;
  public selectedCrop: any;

  public totalLandArea: number = 0;

  public existingMIDetails: any;

  //for multiple datasets
  public preEstimationDataArray: any = [];
  public miEstimationDataArray: any = [];
  public miBOQDataArray: any = [];
  public physicalSurveyDataArray: any = [];
  public sanctionLetterDataArray: any = [];
  public physicalSurveyDetailsArray: any = [];
  public imgVal: any;

  public surveyStage1JE: any = null;
  public surveyStage1SDO: any = null;
  public surveyStage1XEN: any = null;
  public surveyStage2JE: any = null;
  public surveyStage2SDO: any = null;
  public surveyStage2XEN: any = null;
  public calStage1JE: any = null;
  public calStage1DD: any = null;
  public calStage1DA: any = null;
  public calStage1DMICADA: any = null;
  public calStage1Admin: any = null;
  public calStage2JE: any = null;
  public calStage2DA: any = null;
  public calStage2DD: any = null;
  public calStage2DMICADA: any = null;
  public calStage2Admin: any = null;
  public tankStage3Data: any = null;
  public remarksData: any = null;
  public t3Attachments: any = null;
  public t3AttachmentsPondStage1: any = null;
  public t3AttachmentsPondStage2: any = null;
  public t3VendorDetails: any = null;
  public pondStage3Visibility: any = null;
  public sdoTanks2SurveyData: any = null;
  public sdoTank1SurveyData: any = null;
  public xenTanks2SurveyData: any = null;
  public xenTank1SurveyData: any = null;
  public jeTanks2SurveyData: any = null;
  public jeTanks1SurveyData: any = null;

  public pondS1Exist: boolean = false;
  public pondS2Exist: boolean = false;

  public FSTVDetails: any;
  public STVDetails: any;
  public STFDetails: any;
  public RTFDetails: any;
  public PondStage1: any;
  public PondStage2: any;
  public PondStage3: any;

  public showSubsidyDetails: boolean = false;
  public showFarmerShareDepositeDetails: boolean = false;
  public farmerShareDepositeDetails: any;
  public viewLinkMasked:any;
  public isAdmin_DMICADA: any;

  public displayLandOwnerDialog: boolean = false;
  public landOwnerDetails : any = [];
  public showLandOwnerDetails: boolean = false;
  public isDAorDMICADA: boolean = false;

  public isLandOwnerDetFetching: boolean = false;
  public isNewKhewatNoFetching: boolean = false;
  loadingText: string = 'Fetching Owner Details from Land Revenue Department';
  loadingTextNewKhewat: string = 'Fetching New Khewat No from Land Revenue Department';
  private dotCount: number = 0;
  private maxDots: number = 3;
  private interval: any;

  public selLandForOwnerdetails: any = {};
  public kewatNo: any = null;
  public displayFindKhewatDialog: boolean = false;
  public morabbaNoForNewKhewat: any = null;
  public killaNoForNewKhewat: any = null;

  public isDDEW_JEEW : boolean = false;
  public userRole: any;

  public landOwnerDetailsErrorMsg: any = null;

  public showHiddenButton: boolean = false;
  public request1complete: boolean = false;
  public request2complete: boolean = false;
  public landDetailedInfo: any = [];
  public isAppdetailsLoading: boolean = true;

  public newKhewatNo: any = [];

  constructor(
    private route: ActivatedRoute,
    private _dashboardService: DashboardService,
    private ofService: OnFarmMiService,
    private messageService: MessageService,
    private farmerAppSer: FarmersApplicationService,
    private sanitizer: DomSanitizer,
    private deptDashBoardService: DepartmentDashboardService,
    private vendorService: VendorDashboardService,
    private router: Router,
    private cryptoJsService: CryptoJsService,
    private challanMIService: ChallanService,
    private jeService: JEService,
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService,
    private location: Location,
  ) {}

  ngOnInit() {
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]); 
    this.userRole = JSON.parse(payload)?.sub;

    if(this.userRole == 'DD Associate' || this.userRole == 'DMICADA' || this.userRole == 'DD-EW' || this.userRole == 'JE-EW'){
      if(this.userRole == 'DD Associate' || this.userRole == 'DMICADA'){
        this.isDAorDMICADA = true;
      }else if(this.userRole == 'DD-EW' || this.userRole == 'JE-EW'){
        this.isDDEW_JEEW = true;
      }
      this.showLandOwnerDetails = true;
    }else{
      this.isDAorDMICADA = false;
      this.isDDEW_JEEW = false;
      this.showLandOwnerDetails = false;
    }
    if(this.userRole == 'admin' || this.userRole == 'DMICADA'){
      this.isAdmin_DMICADA = true;
    }else{
      this.isAdmin_DMICADA = false;
    }
    
    this.getCropMaster();

    this.route.queryParams.subscribe(params => {
      const encryptedMobile = params['appId'];
      if (encryptedMobile) {
        this.appId = this.cryptoJsService.DecryptData(encryptedMobile);
      }else{
        setTimeout(()=> this.onClickBack(), 1300);
        // this.appId = this.cryptoJsService.DecryptData(this.route.snapshot.paramMap.get('appId'));
      }
    });

    // this.appId = this.cryptoJsService.DecryptData(this.route.snapshot.paramMap.get('appId'));


    if (!this.appId) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Data Error : Cannot Load Form Due to Missing Application Id.',
      });
      return;
    }
    // this.vendorId = this.route.snapshot.paramMap.get('vendorId');
    // this.programId = this.route.snapshot.paramMap.get('programId');
    // this.autoId = this.route.snapshot.paramMap.get('autoId');
    // this.userId = this.route.snapshot.paramMap.get('userId');

    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerConfData = new Map(encData);
    // let farmerData = farmerConfData.get('farmerDetails');
    // this.farmerId = farmerData?.['Farmer_ID'];
    let farmerId = farmerConfData.get('Farmer_Id_');
    this.farmerId = farmerId;

    if (this.appId) {
      this.getApplicationDetails(this.appId);
      this.getExistingMIDetails(this.appId);
      this.getApplicationStatus(this.appId);
      // this.getPondVerDataSatge1(this.appId);
      // this.getPondVerDataSatge2(this.appId);
      this.getPondVerDataSatge3(this.appId);
      this.getGetSubsidyDetails(this.appId);
      this.challanPaymentDetails(this.appId);
    }
  }

  getCropMaster() {
    // this.loader.start();
    this.vendorService
      .getCropMaster()
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.cropType = res;
          // this.loader.close();
        },
        error: () => {
          // this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Crop Master not loaded.',
          });
        },
      });
  }

  onClickApp(memAppId) {
    let statusCodeEncrypted = this.cryptoJsService.Encrypt(this.statusCode);
    const link = this.router.serializeUrl(
      this.router.createUrlTree([
        this.router.url.split('/')[1],
        'print',
      ],  { queryParams: { appId:this.cryptoJsService.Encrypt(memAppId.toString()) } }));
    window.open(link, '_blank');
  }
  // }

  getPastSubsidiesByFarmerId(farmerID) {
    // if (this.farmerId) {
    // this.loader.start();
    this.ofService
      .GetFarmerPastSubsidyByFarmerId(farmerID)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.farmerPreviousSubsidies = data;
          // this.loader.close();
        },
        error: () => {
          // this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Farmer Previous Subsidies not loaded.',
          });
        },
      });
    // }
  }

  getPastSubsidiesByMultipleFarmerIds(GroupTableData) {
    let farmerIds = [];
    GroupTableData.forEach((farmer) => {
      farmerIds.push(farmer.FarmerID.toString());
    });
    if (farmerIds.length) {
      // this.loader.start();
      this.ofService
        .GetFarmerPastSubsidyByMultipleFarmerIds(farmerIds)
        .pipe(first())
        .subscribe({
          next: (data) => {
            this.farmerPreviousSubsidies = data;
            // this.loader.close();
          },
          error: () => {
            // this.loader.close();
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: 'Data error! Farmer Previous Subsidies not loaded.',
            });
          },
        });
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Data error! Group-Farmers Previous Subsidies not Fetched.',
      });
      return;
    }
  }

  getApplicationDetails(appId) {
    this.loader.start();
    this._dashboardService.getApplicationByAppId(appId).subscribe((res) => {
      this.isAppdetailsLoading = false;
      this.appDataLoadedEvent.emit(this.isAppdetailsLoading.toString());
      this.loader.close();
      if (res) {
        this.applicationDetails = res;

        // res.ListViewFormData = [
        //   {
        //     "AutoId": 372819,
        //     "ProgId": 2,
        //     "VendorId": "302",
        //     "User_ID": "farmer"
        //   },
        //   {
        //     "AutoId": 372819,
        //     "ProgId": 2,
        //     "VendorId": "302",
        //     "User_ID": "farmer"
        //   }
        // ]

        if (res?.ListViewFormData && res?.ListViewFormData.length > 0) {
          res?.ListViewFormData.forEach((val) => {
            let autoId = val?.AutoId;
            let progId = val?.ProgId
            let userId = val?.User_ID;
            let vendorId = val?.VendorId;

            if (autoId!=null && userId!=null) {
              this.getCalculatedSubsidyDataForMIPhys(autoId, userId);
            }

            if (autoId!=null && progId!=null) {
              this.getPreEstimationData(this.appId, progId);
            }

            if (this.appId!=null && progId!=null) {
              this.getSanctionLetterData(this.appId, progId);
            }

            if (vendorId!=null && progId!=null) {
              this.getMIEstimationData(this.appId, vendorId, progId);
              this.getMIBOQData(this.appId, vendorId, progId);
            }

            if (autoId!=null && userId!=null) {
              this.getPhysicalSurveyData(autoId, userId);
            }
          });
        }

        if (
          this.applicationDetails?.FarmerLand &&
          this.applicationDetails?.FarmerLand.length > 0
        ) {
          this.applicationDetails?.FarmerLand.forEach(
            (val) => (this.totalLandArea += parseFloat(val.totalArea))
          );
        }

        this.totalArea = 0;
        if (this.applicationDetails?.New_MI_Datas && this.applicationDetails?.New_MI_Datas.length > 0) {
          this.applicationDetails.New_MI_Datas = this.applicationDetails.New_MI_Datas.filter((val) => {
            return (!(val?.miVendorName == null || val?.miVendorName == '') && !(val?.VendorCode == null && val?.VendorCode == 0))});
          this.applicationDetails.New_MI_Datas.forEach(
            (val) => (this.totalArea += parseFloat(val.totalArea))
          );
        }

        let farmerId = res.Farmer_ID;
        if (res?.GroupTableData) {
          this.getPastSubsidiesByMultipleFarmerIds(res?.GroupTableData);
        } else {
          this.getPastSubsidiesByFarmerId(farmerId);
        }
        if(this.applicationDetails?.FarmerPersonalData?.Aadhar_No){
          if(this.userRole && (this.userRole ==='DMICADA' || this.userRole ==='DD Associate' || this.userRole ==='CAO' || this.userRole == 'DD-EW' || this.userRole == 'JE-EW' || this.userRole == 'DDMI' || this.userRole == 'DDTank')){
              this.viewLinkMasked = false;
          }
          else{
            this.viewLinkMasked = true;
            this.applicationDetails.FarmerPersonalData.Aadhar_No=this.maskNumber(this.applicationDetails?.FarmerPersonalData?.Aadhar_No)
            this.applicationDetails.FarmerPersonalData.PPP_ID=this.maskNumber(this.applicationDetails?.FarmerPersonalData?.PPP_ID)
          }
        }
      }
    },
    err => {
      this.isAppdetailsLoading = false;
      this.appDataLoadedEvent.emit(this.isAppdetailsLoading.toString());
      this.loader.close();
    });
  }

  getApplicationStatus(appId) {
    // this.loader.start();
    this._dashboardService
      .getApplicationStatusByAppId(appId)
      .subscribe((res) => {
        // this.loader.close();
        if (res) {
          this.applicationStatus = res.replace('Application Status: ', '');
        }
      });
  }

  getPondVerDataSatge1(appId) {
    this.jeService
      .getPondVerDataByAppIdStage1(appId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.PondVerData = data;
          sessionStorage.setItem('pondData', JSON.stringify(data));
        },
        error: () => {
          // this.loader.close();
          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error Message',
          //   detail: 'Data error! Dashboard not loaded.',
          // });
        },
      });
  }

  getPondVerDataSatge2(appId) {
    this.jeService
      .getPondVerDataByAppIdStage2(appId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          if(data?.PondStage2Status == 1){
            this.PondVerDataStage2 = data;
          }
          // sessionStorage.setItem('pondData', JSON.stringify(data));
        },
        error: () => {
          // this.loader.close();
          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error Message',
          //   detail: 'Data error! Dashboard not loaded.',
          // });
        },
      });
  }

  getPondVerDataSatge3(appId) {
    this.jeService
      .getPondVerDataByAppId_SubsidyCalc_Stage3(appId)
      .pipe(first())
      .subscribe({
        next: (res) => {
          if(res){
            this.PondVerDataStage3 = res;
            this.surveyStage1JE = res[1][0];
            if( this.surveyStage1JE?.IsExist==1){
              this.pondS1Exist = true;
            }else{
              this.pondS1Exist = false;
            }
            this.surveyStage1XEN = res[0][0];
            this.surveyStage2JE = res[3][0];
            if( this.surveyStage2JE?.IsExist==1){
              this.pondS2Exist = true;
            }else{
              this.pondS2Exist = false;
            }
            this.surveyStage2XEN = res[2][0];      
            this.calStage1JE = res[5][0];
            this.calStage1DD = res[6][0];
            this.calStage1DA = res[7][0];
            this.calStage1DMICADA = res[8][0];
            this.calStage1Admin = res[4][0];
            this.calStage2JE = res[10][0];
            this.calStage2DD = res[11][0];
            this.calStage2DA = res[12][0];
            this.calStage2DMICADA = res[13][0];
            this.calStage2Admin = res[9][0];
            this.tankStage3Data = res[14][0];
            this.remarksData = res[15][0];
            this.t3Attachments = res[16];
            this.t3VendorDetails = res[17][0];
            this.t3AttachmentsPondStage1 = res[19];
            this.t3AttachmentsPondStage2 = res[20];
            // this.pondStage3Visibility = res[18][0];
            this.jeTanks1SurveyData = res[21][0];
            this.sdoTank1SurveyData = res[22][0];
            this.xenTank1SurveyData = res[23][0];
            this.jeTanks2SurveyData = res[24][0];
            this.sdoTanks2SurveyData = res[25][0];
            this.xenTanks2SurveyData = res[26][0];


            // JE stage 1 start
            if (this.jeTanks1SurveyData.coordinates.length > 0) {
              this.showMapJETankS1 = true;

              let jeOptionTankS1JE = {
                center: { lat: 29.0588, lng: 76.0856 },
                zoom: 17,
                mapTypeId: google.maps.MapTypeId.SATELLITE,
                draggable: true,
              };

              jeOptionTankS1JE.center = {
                "lat": this.jeTanks1SurveyData.coordinates[0]?.Latitude,
                "lng": this.jeTanks1SurveyData.coordinates[0]?.Longitude
              };
              let jeOverlaysTankS1JE = [];

              // add marker
              this.jeTanks1SurveyData?.coordinates.forEach((row, tableIndex) => {
                  jeOverlaysTankS1JE.push(
                    new google.maps.Marker({
                      position: { lat: row?.Latitude, lng: row?.Longitude },
                      title: `${row?.CornerID}`,
                      draggable: false,
                      crossOnDrag: false
                    })
                  );
              })

              // add overlay
              let arr1 = this.jeTanks1SurveyData.coordinates.map(val => ({
                lat: val?.Latitude,
                lng: val?.Longitude
              }))

              jeOverlaysTankS1JE.push(
                new google.maps.Polygon({
                  paths: arr1,
                  strokeOpacity: 0.5,
                  strokeWeight: 1,
                  fillColor: '#1976D2',
                  fillOpacity: 0.35,
                })
              );

              this.jeTanks1SurveyData = {
                ...this.jeTanks1SurveyData,
                newGPSjeArray: {
                  gpsArray : this.jeTanks1SurveyData.coordinates as Array<any>,
                  overlays : jeOverlaysTankS1JE,
                  options: jeOptionTankS1JE
                } 
              }
            } else {
              this.showMapJETankS1 = false;
            }
            // JE stage 1 end
            
            // SDO stage 1 start
            if (this.sdoTank1SurveyData.coordinates.length > 0) {
              this.showMapSDOTankS1 = true;

              let sdoOptionTankS1 = {
                center: { lat: 29.0588, lng: 76.0856 },
                zoom: 17,
                mapTypeId: google.maps.MapTypeId.SATELLITE,
                draggable: true,
              };

              sdoOptionTankS1.center = {
                "lat": this.sdoTank1SurveyData.coordinates[0]?.Latitude,
                "lng": this.sdoTank1SurveyData.coordinates[0]?.Longitude
              };
              let sdoOverlaysTankS1 = [];

              // add marker
              this.sdoTank1SurveyData?.coordinates.forEach((row, tableIndex) => {
                // arr.forEach((row, index) => {
                  sdoOverlaysTankS1.push(
                    new google.maps.Marker({
                      position: { lat: row?.Latitude, lng: row?.Longitude },
                      title: `${row?.CornerID}`,
                      draggable: false,
                      crossOnDrag: false
                    })
                  );
                // });
              })

              // add overlay
              let arr1 = this.sdoTank1SurveyData.coordinates.map(val => ({
                lat: val?.Latitude,
                lng: val?.Longitude
              }))

              sdoOverlaysTankS1.push(
                  new google.maps.Polygon({
                    paths: arr1,
                    strokeOpacity: 0.5,
                    strokeWeight: 1,
                    fillColor: '#1976D2',
                    fillOpacity: 0.35,
                  })
                );

              this.sdoTank1SurveyData = {
                ...this.sdoTank1SurveyData,
                newGPSjeArray: {
                  gpsArray : this.sdoTank1SurveyData.coordinates as Array<any>,
                  overlays : sdoOverlaysTankS1,
                  options: sdoOptionTankS1
                } 
              }
            } else {
              this.showMapSDOTankS1 = false;
            }
            // SDO stage 1 end

            // XEN stage 1 start
            if (this.xenTank1SurveyData.coordinates.length > 0) {
              this.showMapXENTankS1 = true;

              let xenOptionTankS1 = {
                center: { lat: 29.0588, lng: 76.0856 },
                zoom: 17,
                mapTypeId: google.maps.MapTypeId.SATELLITE,
                draggable: true,
              };

              xenOptionTankS1.center = {
                "lat": this.xenTank1SurveyData.coordinates[0]?.Latitude,
                "lng": this.xenTank1SurveyData.coordinates[0]?.Longitude
              };
              let xenOverlaysTankS1 = [];

              // add marker
              this.xenTank1SurveyData?.coordinates.forEach((row, tableIndex) => {
                // arr.forEach((row, index) => {
                  xenOverlaysTankS1.push(
                    new google.maps.Marker({
                      position: { lat: row?.Latitude, lng: row?.Longitude },
                      title: `${row?.CornerID}`,
                      draggable: false,
                      crossOnDrag: false
                    })
                  );
                // });
              })

              // add overlay
              let arr1 = this.jeTanks1SurveyData.coordinates.map(val => ({
                lat: val?.Latitude,
                lng: val?.Longitude
              }))

              xenOverlaysTankS1.push(
                  new google.maps.Polygon({
                    paths: arr1,
                    strokeOpacity: 0.5,
                    strokeWeight: 1,
                    fillColor: '#1976D2',
                    fillOpacity: 0.35,
                  })
                );

              this.xenTank1SurveyData = {
                ...this.xenTank1SurveyData,
                newGPSjeArray: {
                  gpsArray : this.xenTank1SurveyData.coordinates as Array<any>,
                  overlays : xenOverlaysTankS1,
                  options: xenOptionTankS1
                } 
              }
            } else {
              this.showMapXENTankS1 = false;
            }
            // XEN stage 1 end


            // JE stage 2 start
            if (this.jeTanks2SurveyData.coordinates.length > 0) {
              this.showMapJETankS2 = true;

              let jeOptionTankS2 = {
                center: { lat: 29.0588, lng: 76.0856 },
                zoom: 17,
                mapTypeId: google.maps.MapTypeId.SATELLITE,
                draggable: true,
              };

              jeOptionTankS2.center = {
                "lat": this.jeTanks2SurveyData.coordinates[0]?.Latitude,
                "lng": this.jeTanks2SurveyData.coordinates[0]?.Longitude
              };
              let jeOverlaysTankS2 = [];

              // add marker
              this.jeTanks2SurveyData?.coordinates.forEach((row, tableIndex) => {
                // arr.forEach((row, index) => {
                  jeOverlaysTankS2.push(
                    new google.maps.Marker({
                      position: { lat: row?.Latitude, lng: row?.Longitude },
                      title: `${row?.CornerID}`,
                      draggable: false,
                      crossOnDrag: false
                    })
                  );
                // });
              })

              // add overlay
              let arr1 = this.jeTanks1SurveyData.coordinates.map(val => ({
                lat: val?.Latitude,
                lng: val?.Longitude
              }))

              jeOverlaysTankS2.push(
                  new google.maps.Polygon({
                    paths: arr1,
                    strokeOpacity: 0.5,
                    strokeWeight: 1,
                    fillColor: '#1976D2',
                    fillOpacity: 0.35,
                  })
                );

              this.jeTanks2SurveyData = {
                ...this.jeTanks2SurveyData,
                newGPSjeArray: {
                  gpsArray : this.jeTanks2SurveyData.coordinates as Array<any>,
                  overlays : jeOverlaysTankS2,
                  options : jeOptionTankS2
                } 
              }

            } else {
              this.showMapJETankS2 = false;
            }
            // JE stage 2 end

            // SDO stage 2 start
            if (this.sdoTanks2SurveyData.coordinates.length > 0) {
              this.showMapSDOTankS2 = true;

              let sdoOptionTankS2 = {
                center: { lat: 29.0588, lng: 76.0856 },
                zoom: 17,
                mapTypeId: google.maps.MapTypeId.SATELLITE,
                draggable: true,
              };

              sdoOptionTankS2.center = {
                "lat": this.sdoTanks2SurveyData.coordinates[0]?.Latitude,
                "lng": this.sdoTanks2SurveyData.coordinates[0]?.Longitude
              };
              let sdoOverlaysTankS2 = [];

              // add marker
              this.sdoTanks2SurveyData?.coordinates.forEach((row, tableIndex) => {
                // arr.forEach((row, index) => {
                  sdoOverlaysTankS2.push(
                    new google.maps.Marker({
                      position: { lat: row?.Latitude, lng: row?.Longitude },
                      title: `${row?.CornerID}`,
                      draggable: false,
                      crossOnDrag: false
                    })
                  );
                // });
              })

              // add overlay
              let arr1 = this.jeTanks1SurveyData.coordinates.map(val => ({
                lat: val?.Latitude,
                lng: val?.Longitude
              }))

              sdoOverlaysTankS2.push(
                  new google.maps.Polygon({
                    paths: arr1,
                    strokeOpacity: 0.5,
                    strokeWeight: 1,
                    fillColor: '#1976D2',
                    fillOpacity: 0.35,
                  })
                );

              this.sdoTanks2SurveyData = {
                ...this.sdoTanks2SurveyData,
                newGPSjeArray: {
                  gpsArray : this.jeTanks2SurveyData.coordinates as Array<any>,
                  overlays : sdoOverlaysTankS2,
                  options : sdoOptionTankS2
                } 
              }
            } else {
              this.showMapSDOTankS2 = false;
            }
            // SDO stage 2 end
           
            // XEN stage 2 start
            if (this.xenTanks2SurveyData.coordinates.length > 0) {
              this.showMapXENTankS2 = true;

              let xenOptionTankS2 = {
                center: { lat: 29.0588, lng: 76.0856 },
                zoom: 17,
                mapTypeId: google.maps.MapTypeId.SATELLITE,
                draggable: true,
              };

              xenOptionTankS2.center = {
                "lat": this.xenTanks2SurveyData.coordinates[0]?.Latitude,
                "lng": this.xenTanks2SurveyData.coordinates[0]?.Longitude
              };
              let xenOverlaysTankS2 = [];

              // add marker
              this.xenTanks2SurveyData?.coordinates.forEach((row, tableIndex) => {
                // arr.forEach((row, index) => {
                  xenOverlaysTankS2.push(
                    new google.maps.Marker({
                      position: { lat: row?.Latitude, lng: row?.Longitude },
                      title: `${row?.CornerID}`,
                      draggable: false,
                      crossOnDrag: false
                    })
                  );
                // });
              })

              // add overlay
              let arr1 = this.jeTanks1SurveyData.coordinates.map(val => ({
                lat: val?.Latitude,
                lng: val?.Longitude
              }))

              xenOverlaysTankS2.push(
                  new google.maps.Polygon({
                    paths: arr1,
                    strokeOpacity: 0.5,
                    strokeWeight: 1,
                    fillColor: '#1976D2',
                    fillOpacity: 0.35,
                  })
                );

              this.xenTanks2SurveyData = {
                ...this.xenTanks2SurveyData,
                newGPSjeArray: {
                  gpsArray : this.jeTanks2SurveyData.coordinates as Array<any>,
                  overlays : xenOverlaysTankS2,
                  options : xenOptionTankS2
                } 
              }
            } else {
              this.showMapXENTankS2 = false;
            }
            // XEN stage 2 end


          } else{
            this.surveyStage1JE = null;
            this.surveyStage1XEN = null
            this.surveyStage2JE = null;
            this.surveyStage2XEN = null;     
            this.calStage1JE = null;
            this.calStage1DD = null;
            this.calStage1DA = null;
            this.calStage1DMICADA = null;
            this.calStage1Admin = null
            this.calStage2JE = null;
            this.calStage2DD = null;
            this.calStage2DA = null;
            this.calStage2DMICADA = null;
            this.calStage2Admin = null;
            this.tankStage3Data = null;
            this.remarksData = null;null 
          }
          // sessionStorage.setItem('pondData', JSON.stringify(data));
        },
        error: () => {
          // this.loader.close();
          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error Message',
          //   detail: 'Data error! Dashboard not loaded.',
          // });
        },
      });
  }

  getGetSubsidyDetails(appId) {
    this.jeService
      .getSubsidyDetails(appId)
      .pipe(first())
      .subscribe({
        next: (res) => {
          if(res){
            this.STFDetails = res[0][0];
            this.STVDetails = res[1][0];
            this.RTFDetails = res[2][0];
            this.FSTVDetails = res[3][0];
            this.PondStage1 = res[4][0];
            this.PondStage2 = res[5][0];
            this.PondStage3 = res[6][0];
            if(this.STFDetails?.IsExist == 1 || this.STVDetails?.IsExist == 1 || this.RTFDetails?.IsExist == 1 || this.FSTVDetails?.IsExist == 1
              || this.PondStage1?.IsExist == 1 || this.PondStage2?.IsExist == 1 || this.PondStage3?.IsExist == 1){
              this.showSubsidyDetails = true;
            }else{
              this.showSubsidyDetails = false;
            }
          }else{
            this.FSTVDetails = null;
            this.STVDetails = null;
            this.STFDetails = null;
            this.RTFDetails = null;
            this.PondStage1 = null;
            this.PondStage2 = null;
            this.PondStage3 = null;
          }
        },
        error: () => {
          // this.loader.close();
          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error Message',
          //   detail: 'Data error! Dashboard not loaded.',
          // });
        },
      });
  }

  onPrint(divName) {
    // var printContents = document.getElementById(divName).innerHTML;
    // var originalContents = document.body.innerHTML;
    // document.body.innerHTML = printContents;
    // window.print();
    // document.body.innerHTML = originalContents;
    document.body.style.visibility = 'hidden';
    document.getElementById(divName).style.visibility = 'visible';
    window.print();
    document.body.style.visibility = 'visible';
  }

  public viewWorkFlowAllStatus: boolean = false;
  workFlowAllStatus() {
    this.viewWorkFlowAllStatus = true;
    // <app-workFlowAllStatus></app-workFlowAllStatus>
    // this.router.navigate([
    //   `dashboard/${this.route.snapshot.paramMap.get(
    //     'appId'
    //   )}`,
    // ]);
  }

  openFileDialog(filePath) {
    this.rotatableFilePath = filePath;
    this.displayFileDialog = true;
  }

  getSafeUrl() {
    return this.sanitizer.bypassSecurityTrustResourceUrl(
      this.rotatableFilePath
    );
  }

  onCloseDialog() {
    this.displayFileDialog = false;
  }

  @ViewChild('myname') myname: ElementRef;
  rotationAmount = 0;
  scalingAmount = 1;
  transformImage(direction, scale) {
    if (direction) {
      this.rotationAmount += direction == 'left' ? -90 : 90;
    }
    if (scale) {
      this.scalingAmount += scale == 'zoom-out' ? -0.1 : 0.1;
    }
    this.myname.nativeElement.style.transform = `rotate(${this.rotationAmount}deg) scale(${this.scalingAmount})`;
  }

  numberEquals(num1, num2) {
    return Number(num1) == Number(num2);
  }

  // onPrintSanctionLetter(divName) {
  //   this.isPrintClicked = true;
  //   var printContents = document.getElementById(divName).innerHTML;
  //   var originalContents = document.body.innerHTML;
  //   document.body.innerHTML = printContents;
  //   window.print();
  //   document.body.innerHTML = originalContents;
  // }

  imageClick(index: number, val) {
    this.activeIndex = index;
    this.displayCustom = true;
    this.imgVal = val;
  }

  imageClick1(index: number, val) {
    this.activeIndex = index;
    this.displayCustom1 = true;
    this.imgVal = val;
  }

  //pre-estimation
  getPreEstimationData(appId, programId) {
    if (appId && programId) {
      this.deptDashBoardService
        .getApplicationDataOfPreEstimation(appId, programId)
        .pipe(first())
        .subscribe({
          next: (data) => {
            this.preEstimateDetails = data;

            if (
              this.preEstimateDetails.CropTypeID &&
              this.preEstimateDetails.CropId
            ) {
              this.cropType.forEach((res) => {
                if (res.data === data.CropTypeID) {
                  // this.selectedCropType = res.label;
                  let crop = res.children;
                  crop.forEach((res2) => {
                    if (res2.data === data.CropId) {
                      this.preEstimateDetails = {
                        ...data,
                        selectedCropType: res?.label,
                        selectedCrop: res2.label,
                      };
                      // this.selectedCrop = res2.label;
                    }
                  });
                  return;
                }
              });
            }

            if (this.preEstimateDetails.listGPSCoordinates.length > 0) {
              this.showMapPreEstimate = true;

              let preEstimateOption = {
                center: { lat: 29.0588, lng: 76.0856 },
                zoom: 17,
                mapTypeId: google.maps.MapTypeId.SATELLITE,
                draggable: true,
              };

              preEstimateOption.center = {
                "lat": this.preEstimateDetails.listGPSCoordinates[0][0]?.Latitude,
                "lng": this.preEstimateDetails.listGPSCoordinates[0][0]?.Longitude
              };
              let preEatimateOverlays = [];

              // add marker
              this.preEstimateDetails.listGPSCoordinates.forEach((arr, tableIndex) => {
                arr.forEach((row, index) => {
                  preEatimateOverlays.push(
                    new google.maps.Marker({
                      position: { lat: row?.Latitude, lng: row?.Longitude },
                      title: `${row?.CornerID}`,
                      draggable: false,
                      crossOnDrag: false
                    })
                  );
                });
              })

              // add overlay

              // preEatimateOverlays.forEach((val, index) => {
              //   if(val?.fillColor){
              //     preEatimateOverlays.splice(index, 1);
              //   }
              // })
          
              this.preEstimateDetails.listGPSCoordinates.forEach(arr => {
                let arr1 = arr.map(val => ({
                  lat: val?.Latitude,
                  lng: val?.Longitude
                }))
                preEatimateOverlays.push(
                  new google.maps.Polygon({
                    paths: arr1,
                    strokeOpacity: 0.5,
                    strokeWeight: 1,
                    fillColor: '#1976D2',
                    fillOpacity: 0.35,
                  })
                );
              })

              this.preEstimateDetails = {
                ...this.preEstimateDetails,
                newGPSArray: {
                  gpsArray : this.preEstimateDetails.listGPSCoordinates,
                  preEatimateOverlays : preEatimateOverlays,
                  preEstimateOption: preEstimateOption
                } 
              }              
            } else {
              this.showMapPreEstimate = false;
            }

            this.preEstimationDataArray.push(this.preEstimateDetails);
          },
          error: () => {},
        });
    }
  }

  getMIEstimationData(appId, vendorId, programId) {
    if (appId && vendorId && programId) {
      this.deptDashBoardService
        .getVendorMIEstimation(this.appId, vendorId, programId)
        .pipe(first())
        .subscribe({
          next: (data) => {
            if (data?.CropTypeID && data?.CropID) {
              this.cropType.forEach((res) => {
                if (res.data === data.CropTypeID) {
                  // this.selectedCropType = res.label;
                  let crop = res.children;
                  crop.forEach((res2) => {
                    if (res2.data === data.CropID) {
                      data = {
                        ...data,
                        selectedCropType: res?.label,
                        selectedCrop: res2.label,
                      };
                      // this.selectedCrop = res2.label;
                    }
                  });
                  return;
                }
              });
            }

            // if(data?.EstimationComponentDetail && data?.EstimationComponentDetail.length > 0){
            //   data?.EstimationComponentDetail.map(val => ({
            //     ...val,
            //     totalCost: val.Price*val.Quantity
            //   }))
            //   let componentTotal = 0;
            //   data?.EstimationComponentDetail.forEach(val => {
            //     componentTotal += val.Price*val.Quantity;
            //   })

            //   data = {
            //     ...data,
            //     componentTotal: componentTotal
            //   }
            // }

            if(data?.AppID){
              this.miEstimationDataArray.push(data);
            }
          },
          error: () => {
            // this.loader.close();
            // this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data Error : Vendor Consent Form Not Loaded' });
          },
        });
    }
  }

  getExistingMIDetails(appId){
    this._dashboardService.getExistingMIDetails(appId).subscribe((res) =>{
      this.existingMIDetails = res;
    })
  }

  getSanctionLetterData(appId, progID) {
    this.challanMIService
      .getSanctionLetterData(appId, progID)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.sanctionLetterDataArray.push(res);
        },
        error: (err) => {
          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error Message',
          //   detail: err,
          // });
        },
      });
  }

  getMIBOQData(appId, vendorId, programId) {
    if (appId && vendorId && programId) {
      this.deptDashBoardService
        .getVendorMIBOQ(this.appId, vendorId, programId)
        .pipe(first())
        .subscribe({
          next: (data) => {
            // this.appDetails = data;
            // this.vendorApplicationDetails = data;
            if (data?.BoqStatus == 1) {
              this.miBOQDataArray.push(data);
            }
          },
          error: () => {
            // this.loader.close();
            // this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data Error : Vendor Consent Form Not Loaded' });
          },
        });
    }
  }

  getPhysicalSurveyData(autoId, userId) {
    if (autoId && userId) {
      this.jeService
        .getApplicationDataForPhysicalVerification(autoId, userId)
        .pipe(first())
        .subscribe({
          next: (data) => {
            this.calculatedSubsidyDataForMIPhys = data;
          },
          error: () => {
            // this.loader.close();
            // this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data Error : Vendor Consent Form Not Loaded' });
          },
          complete: () => {
            // this.loader.start();
            this.jeService
              .getApplicationDataForPhysicalVerification_CalculatedSubsidy(
                autoId,
                userId
              )
              .pipe(first())
              .subscribe({
                next: (data) => {
                  if (data['PhySurveyStatus'] == 1) {

                    // data = {
                    //   ...data,
                    //   listGPSCoordinatesXEN : [[
                    //     {
                    //         "CornerID": 1,
                    //         "Latitude": 29.718053817749,
                    //         "Longitude": 75.54434967041,
                    //         "UserId": "JEFatehabad2"
                    //     },
                    //     {
                    //         "CornerID": 2,
                    //         "Latitude": 29.717578887939,
                    //         "Longitude": 75.544364929199,
                    //         "UserId": "JEFatehabad2"
                    //     },
                    //     {
                    //         "CornerID": 3,
                    //         "Latitude": 29.717555999756,
                    //         "Longitude": 75.545417785645,
                    //         "UserId": "JEFatehabad2"
                    //     },
                    //     {
                    //         "CornerID": 4,
                    //         "Latitude": 29.718078613281,
                    //         "Longitude": 75.545471191406,
                    //         "UserId": "JEFatehabad2"
                    //     }
                    // ]],
                    //   listGPSCoordinatesJE : [[
                    //     {
                    //         "CornerID": 1,
                    //         "Latitude": 29.718053817749,
                    //         "Longitude": 75.54434967041,
                    //         "UserId": "JEFatehabad2"
                    //     },
                    //     {
                    //         "CornerID": 2,
                    //         "Latitude": 29.717578887939,
                    //         "Longitude": 75.544364929199,
                    //         "UserId": "JEFatehabad2"
                    //     },
                    //     {
                    //         "CornerID": 3,
                    //         "Latitude": 29.717555999756,
                    //         "Longitude": 75.545417785645,
                    //         "UserId": "JEFatehabad2"
                    //     },
                    //     {
                    //         "CornerID": 4,
                    //         "Latitude": 29.718078613281,
                    //         "Longitude": 75.545471191406,
                    //         "UserId": "JEFatehabad2"
                    //     }
                    // ]]
                    // }

                    this.physicalSurveyDetails = data;

                    if (this.physicalSurveyDetails.listGPSCoordinatesJE.length > 0) {
                      this.showMapJE = true;

                      let jeOption = {
                        center: { lat: 29.0588, lng: 76.0856 },
                        zoom: 17,
                        mapTypeId: google.maps.MapTypeId.SATELLITE,
                        draggable: true,
                      };
        
                      jeOption.center = {
                        "lat": this.physicalSurveyDetails.listGPSCoordinatesJE[0][0]?.Latitude,
                        "lng": this.physicalSurveyDetails.listGPSCoordinatesJE[0][0]?.Longitude
                      };
                      let jeOverlays = [];
        
                      // add marker
                      this.physicalSurveyDetails.listGPSCoordinatesJE.forEach((arr, tableIndex) => {
                        arr.forEach((row, index) => {
                          jeOverlays.push(
                            new google.maps.Marker({
                              position: { lat: row?.Latitude, lng: row?.Longitude },
                              title: `${row?.CornerID}`,
                              draggable: false,
                              crossOnDrag: false
                            })
                          );
                        });
                      })
        
                      // add overlay
                      this.physicalSurveyDetails.listGPSCoordinatesJE.forEach(arr => {
                        let arr1 = arr.map(val => ({
                          lat: val?.Latitude,
                          lng: val?.Longitude
                        }))

                        jeOverlays.push(
                          new google.maps.Polygon({
                            paths: arr1,
                            strokeOpacity: 0.5,
                            strokeWeight: 1,
                            fillColor: '#1976D2',
                            fillOpacity: 0.35,
                          })
                        );
                      })
        
                      this.physicalSurveyDetails = {
                        ...this.physicalSurveyDetails,
                        newGPSjeArray: {
                          gpsArray : this.physicalSurveyDetails.listGPSCoordinatesJE,
                          overlaysJE : jeOverlays,
                          optionsJE: jeOption
                        } 
                      }   
                      
                    } else {
                      this.showMapJE = false;
                    }

                    if (this.physicalSurveyDetails.listGPSCoordinatesXEN.length > 0) {
                      this.showMapXEN = true;

                      let xenOption = {
                        center: { lat: 29.0588, lng: 76.0856 },
                        zoom: 17,
                        mapTypeId: google.maps.MapTypeId.SATELLITE,
                        draggable: true,
                      };
        
                      xenOption.center = {
                        "lat": this.physicalSurveyDetails.listGPSCoordinatesXEN[0][0]?.Latitude,
                        "lng": this.physicalSurveyDetails.listGPSCoordinatesXEN[0][0]?.Longitude
                      };
                      let xenOverlays = [];
        
                      // add marker
                      this.physicalSurveyDetails.listGPSCoordinatesXEN.forEach((arr, tableIndex) => {
                        arr.forEach((row, index) => {
                          xenOverlays.push(
                            new google.maps.Marker({
                              position: { lat: row?.Latitude, lng: row?.Longitude },
                              title: `${row?.CornerID}`,
                              draggable: false,
                              crossOnDrag: false
                            })
                          );
                        });
                      })
        
                      // add overlay
                      this.physicalSurveyDetails.listGPSCoordinatesXEN.forEach(arr => {
                        let arr1 = arr.map(val => ({
                          lat: val?.Latitude,
                          lng: val?.Longitude
                        }))
                        xenOverlays.push(
                          new google.maps.Polygon({
                            paths: arr1,
                            strokeOpacity: 0.5,
                            strokeWeight: 1,
                            fillColor: '#1976D2',
                            fillOpacity: 0.35,
                          })
                        );
                      })
        
                      this.physicalSurveyDetails = {
                        ...this.physicalSurveyDetails,
                        newGPSxenArray: {
                          gpsArray : this.physicalSurveyDetails.listGPSCoordinatesXEN,
                          overlaysXEN : xenOverlays,
                          optionsXEN: xenOption
                        } 
                      }   
                      
                    } else {
                      this.showMapXEN = false;
                    }

                    if (this.physicalSurveyDetails?.listGPSCoordinatesSDO?.length > 0) {
                      this.showMapSDO = true;

                      let sdoOption = {
                        center: { lat: 29.0588, lng: 76.0856 },
                        zoom: 17,
                        mapTypeId: google.maps.MapTypeId.SATELLITE,
                        draggable: true,
                      };
        
                      sdoOption.center = {
                        "lat": this.physicalSurveyDetails?.listGPSCoordinatesSDO[0][0]?.Latitude,
                        "lng": this.physicalSurveyDetails?.listGPSCoordinatesSDO[0][0]?.Longitude
                      };
                      let sdoOverlays = [];
        
                      // add marker
                      this.physicalSurveyDetails?.listGPSCoordinatesSDO.forEach((arr, tableIndex) => {
                        arr.forEach((row, index) => {
                          sdoOverlays.push(
                            new google.maps.Marker({
                              position: { lat: row?.Latitude, lng: row?.Longitude },
                              title: `${row?.CornerID}`,
                              draggable: false,
                              crossOnDrag: false
                            })
                          );
                        });
                      })
        
                      // add overlay
                      this.physicalSurveyDetails?.listGPSCoordinatesSDO.forEach(arr => {
                        let arr1 = arr.map(val => ({
                          lat: val?.Latitude,
                          lng: val?.Longitude
                        }))
                        sdoOverlays.push(
                          new google.maps.Polygon({
                            paths: arr1,
                            strokeOpacity: 0.5,
                            strokeWeight: 1,
                            fillColor: '#1976D2',
                            fillOpacity: 0.35,
                          })
                        );
                      })
        
                      this.physicalSurveyDetails = {
                        ...this.physicalSurveyDetails,
                        newGPSsdoArray: {
                          gpsArray : this.physicalSurveyDetails?.listGPSCoordinatesSDO,
                          overlaysSDO : sdoOverlays,
                          optionsSDO: sdoOption
                        } 
                      }   
                      
                    } else {
                      this.showMapSDO = false;
                    }


                    if (this.calculatedSubsidyDataForMIPhys) {
                      this.physicalSurveyDetails = {
                        ...this.physicalSurveyDetails,
                        calculatedSubsidyDataForMIPhys:
                          this.calculatedSubsidyDataForMIPhys,
                      };
                      this.physicalSurveyDetailsArray.push(
                        this.physicalSurveyDetails
                      );
                    } else {
                      this.physicalSurveyDetailsArray.push(
                        this.physicalSurveyDetails
                      );
                    }
                  }
                },
                error: () => {
                  // this.loader.close();
                  // this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data Error : Form Not Loaded' });
                },
              });
          },
        });
    }
  }

  getCalculatedSubsidyDataForMIPhys(autoId, userId) {
    this.jeService
      .getApplicationDataForPhysicalVerification(autoId, userId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.calculatedSubsidyDataForMIPhys = data;
        },
        error: () => {
          // this.loader.close();
          // this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data Error : Vendor Consent Form Not Loaded' });
        },
      });
  }

  challanPaymentDetails(appId){
    // this.loader.start();
    let sub = this.deptDashBoardService 
      .getChallanPaymentDetails(appId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.loader.close();
          if(data && data.length>0){
            this.showFarmerShareDepositeDetails =  true;
            this.farmerShareDepositeDetails = data[0][0];
          }else{
            this.showFarmerShareDepositeDetails =  false;
            this.farmerShareDepositeDetails = [];
            // this.messageService.add({
            //   severity: 'error',
            //   summary: 'Error Message',
            //   detail: 'Data Not Found',
            // });
          }
        },
        error: (err) => {
          this.showFarmerShareDepositeDetails =  false;
          this.farmerShareDepositeDetails = [];
          // this.loader.close();
          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error Message',
          //   detail: err,
          // });
        },
      });
  }
  maskNumber(number:any) {
    let id = number.toString();
     if(id){
      return id.slice(0, -4).replace(/./g, 'X') + id.slice(-4); //regex used here
    }
    return null 
 }

  onClickBack(){
    this.location.back();
  }

  beforeCheckingLandStatus(val){
    this.selLandForOwnerdetails = val;
    this.kewatNo = val?.Khewat;
    this.morabbaNoForNewKhewat = val?.morabbaNo;
    this.killaNoForNewKhewat = this.getAfterDoubleSlash(val?.killaNo);

    console.log('selLandForOwnerdetails', this.selLandForOwnerdetails);
    this.displayLandOwnerDialog = true;
  }

  submitKewatNo(){
    this.landOwnerDetails = [];
    this.landOwnerDetailsErrorMsg = null;
    if(this.kewatNo){
      this.checkLandStatus(this.selLandForOwnerdetails);
    }
  }

  checkLandStatus(val){
    this.startLoadingAnimation();
    // this.displayLandOwnerDialog = true;
    let reqBody1 = {
      districtCode: val?.R_Dis_Code,
      tehsilCode: val?.R_Teh_Code,
      nvCode: val?.R_Rev_Code,
      khewat: this.kewatNo,
      format: "json",
      farmerId: val?.farmerId
    }

    // let reqBody1 = {
    //   "districtCode": "02",
    //   "tehsilCode": "007",
    //   "nvCode": "01931",
    //   "khewat": this.kewatNo,
    //   "format": "json"
    // }

    // let reqBody2 = {  
    //   "districtCode": "02",  
    //   "tehsilCode": "007",  
    //   "nvCode": "01931",  
    //   "format": "json"
    // }

    // let reqBody2 = {
    //   districtCode: val?.R_Dis_Code,
    //   tehsilCode: val?.R_Teh_Code,
    //   nvCode: val?.R_Rev_Code,
    //   format: "json"
    // }

    this.getLandOwnerDetails(reqBody1);
    // this.getLandKhewatDetails(reqBody2);
  }

  getLandKhewatDetails(reqBody){
    this.loader.start();
    this.vendorService 
      .getLandKhewatByKhasra(reqBody)
      .pipe(first())
      .subscribe({
        next: (resp) => {
          this.landOwnerDetails = resp;
          this.loader.close();
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  getLandOwnerDetails(reqBody){
    // this.loader.start();
    this.isLandOwnerDetFetching = true;
    this.vendorService 
      .getLandOwnersDetail(reqBody)
      .pipe(first())
      .subscribe({
        next: (resp) => {         
          this.loader.close();
          this.stopLoadingAnimation();
          // this.isLandOwnerDetFetching = false;
          if (resp?.length > 0) {
            this.landOwnerDetails = resp;
            this.landOwnerDetailsErrorMsg = null;

            let reqBody1 = {
              "districtCode": reqBody.districtCode,
              "tehsilCode": reqBody.tehsilCode,
              "nvCode": reqBody?.nvCode,
              "khewat": reqBody?.khewat,
              "format": "json"
            }
            this.getLandGetAreaByKhewat(reqBody)
            this.getKhasraAreaByKhewatNVCode(reqBody1)

          }else{
            this.landOwnerDetails = [];
            this.landOwnerDetailsErrorMsg = `Someting went wrong. Please try again. ${resp}`;;
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data not found',
            });
          }
        },
        error: (err) => {
          this.stopLoadingAnimation();
          this.isLandOwnerDetFetching = false;
          this.showHiddenButton = false;
          this.landOwnerDetailsErrorMsg = `Someting went wrong. Please try again. ${err}`;
          this.landOwnerDetails = [];
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }
  
  getKhasraAreaByKhewatNVCode(reqBody) {
    // this.loader.start();
    this.vendorService
      .getKhasraAreaKhewatByNVCODE2Khewat(reqBody)
      .pipe(first())
      .subscribe({
        next: (resp) => {
          if(this.request1complete){
            // this.loader.close();
            this.isLandOwnerDetFetching = false;
          }

          if (resp?.status == 200 && resp?.msg != 'Someting went wrong') {
            this.showHiddenButton = true;
            
            this.landDetailedInfo = JSON.parse(resp?.msg);  
          } else {
            this.showHiddenButton = false;
            this.landDetailedInfo = [];

            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: `Data not found. ${resp?.msg}`,
            });
          }
        },
        error: (err) => {
          this.showHiddenButton = false;
          this.landDetailedInfo = [];
          if(this.request1complete){
            // this.loader.close();
            this.isLandOwnerDetFetching = false;
          }

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
        complete: () => {
          this.request2complete = true;
        }
      });
  }

  getLandGetAreaByKhewat(reqBody) {
    // this.loader.start();
    this.vendorService
      .getLandGetAreaByKhewat(reqBody)
      .pipe(first())
      .subscribe({
        next: (resp) => {
          if(this.request2complete){
            // this.loader.close();
            this.isLandOwnerDetFetching = false;
          }

          if (resp?.status == 200 && resp?.msg != 'Someting went wrong') {
            this.showHiddenButton = true;
            
            const khewatArea = JSON.parse(resp?.msg)[0]?.area;
            const regex = /(\d+)\s*Kanal\s*(\d+)\s*Marla/;
            const values = khewatArea.match(regex);

            const karnal = values[0] ? parseInt(values[1], 10) : 0;
            const marla = values[2] ? parseInt(values[2], 10) : 0;

            this.landOwnerDetails = this.landOwnerDetails.map(val => ({
              ...val,
              khewat_area: khewatArea,
              valKanal: karnal,
              valMarla: marla,
              totalArea_InAcres:  ((karnal * 20) + marla)/20*0.125,
              owner_hissa: ((karnal * 20) + marla)*((val?.Bhag).split('/').map(Number)[0]/(val?.Bhag).split('/').map(Number)[1])/20*0.125,
            }));
          } else {
            this.showHiddenButton = false;
            this.landOwnerDetails = [];

            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: `Data not found. ${resp?.msg}`,
            });
          }
        },
        error: (err) => {
          this.showHiddenButton = false;
          this.landOwnerDetails = [];
          if(this.request1complete){
            // this.loader.close();
            this.isLandOwnerDetFetching = false;
          }

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
        complete: () => {
          this.request1complete = true;
        }
      });
  }

  startLoadingAnimation(): void {
    this.interval = setInterval(() => {
      this.dotCount = (this.dotCount + 1) % (this.maxDots + 1);
      this.loadingText = `Fetching Owner Details from Land Revenue Department${'.'.repeat(this.dotCount)}`;
    }, 500); // Adjust the interval (in ms) to control the speed of the animation
  }

  stopLoadingAnimation(): void {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  onCloseLandOwnerDialog(){
    this.displayLandOwnerDialog = false;
    this.stopLoadingAnimation();
    this.selLandForOwnerdetails = null;
    this.kewatNo = null;
  
    this.landOwnerDetails = [];
    this.landOwnerDetailsErrorMsg = null;

    this.kewatNo = null;
    this.morabbaNoForNewKhewat = null;
    this.killaNoForNewKhewat = null;
  }

  onCloseFindKhewat(){
    this.displayFindKhewatDialog = false;

    this.morabbaNoForNewKhewat = this.selLandForOwnerdetails?.morabbaNo;
    this.killaNoForNewKhewat = this.getAfterDoubleSlash(this.selLandForOwnerdetails?.killaNo);
  }

  getAfterDoubleSlash(str) {
    let splitVal = str.split("//");
    return splitVal[1] ? splitVal[1] : "";
  }

  onClickGetNewKhewat(){
    this.displayFindKhewatDialog = true;
  }

  submitKhasraNo(){
    this.newKhewatNo = [];
    this.getNewKhewatByKhasra(this.selLandForOwnerdetails);
  }

  getNewKhewatByKhasra(val){
    // this.displayLandOwnerDialog = true;
    let reqBody1 = {
      districtCode: val?.R_Dis_Code,
      tehsilCode: val?.R_Teh_Code,
      nvCode: val?.R_Rev_Code,
      must: this.morabbaNoForNewKhewat,
      khasra: this.killaNoForNewKhewat,
      format: "json",
    }

    this.getnewKhewatDetail(reqBody1);
  }

  getnewKhewatDetail(reqBody){
    this.isNewKhewatNoFetching = true;
    this.vendorService 
      .getKhewatByKhasra(reqBody)
      .pipe(first())
      .subscribe({
        next: (resp) => {
          this.newKhewatNo = JSON.parse(resp);
          this.isNewKhewatNoFetching = false;

          if(this.newKhewatNo?.length == 0){
            this.messageService.add({
              severity: 'Warn',
              summary: 'Info Message',
              detail: 'Data not found',
            });
          }
        },
        error: (err) => {
          this.newKhewatNo = [];
          this.isNewKhewatNoFetching = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  onClickUpdateLandKhewat(){
    let oldKhewat = this.selLandForOwnerdetails?.Khewat;
    let oldFinYear = this.selLandForOwnerdetails?.Year;

    let landId = this.selLandForOwnerdetails?.LandID;
    let newKhewat = this.landDetailedInfo[0]?.khewat;
    let newFinyear = this.landDetailedInfo[0]?.period;

    let reqBody = {
      LandId: this.selLandForOwnerdetails?.LandID,
      Khewat: this.landDetailedInfo[0]?.khewat,
      KhewatYear: this.landDetailedInfo[0]?.period,
    }

    this.updateKhewat(reqBody);
    console.log('reqBody', reqBody);
  }

  updateKhewat(reqBody){
    let reqBodyAfterEncypt = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }

    this.loader.start();
    this.vendorService 
      .updateKhewatByLandId(reqBodyAfterEncypt)
      .pipe(first())
      .subscribe({
        next: (resp) => {
          this.loader.close();

          if(resp == "Record updated successfully"){
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: resp,
            });
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          }else {
            this.messageService.add({
              severity: 'warn',
              summary: 'Info Message',
              detail: resp,
            });
          }
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }
}
